<template>
  <div v-if="showFlag" class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      会計事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <BusinessHeader v-if="this.isloginHendle"></BusinessHeader>
    <HeaderNav menuflg="2" v-else></HeaderNav>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li v-if="!this.isloginHendle">
              <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }"
                >メインページ</router-link
              >
            </li>
            <li v-if="!this.isloginHendle">
              <router-link :to="{ name: 'STFMFM02C01' }"
                  >ファイル管理</router-link
              >
            </li>
            <li>
              <span class="current" v-bind:class="{'ico-home': this.isloginHendle}">ファイル一覧</span>
            </li>
          </ul>
        </div>
        <div class="content-header">
          <h1 class="h1">ファイル一覧</h1>
          <div class="sub-title">{{businessOperatorCode + "_" + businessOperatorName}}</div>
        </div>
        <!-- ****  メッセージ表示領域 **** -->
        <div class="frm-row">
          <div class="frm-item grow left">
            <p class="errMsg title-ico ico-warning" v-show="errors != ''">
              <ErrorMessage :errors="errors"></ErrorMessage>
            </p>
          </div>
        </div>
        <div class="content-body2" >
          <div class="inner">
            <!-- No4「ファイル一覧_電子取引・スキャナ保存」画面で左メニュー[電子取引・スキャナ保存]の幅を変更 -->
            <nav class="content-nav2">
              <ul>
                <!-- No4「ファイル一覧_電子取引・スキャナ保存」画面で左メニュー[電子取引・スキャナ保存]の文言変更 -->
                <li class="menu1" :class="{'current':isShowSTFMFM02C02FileList}" @click="clickDenshi"><a href="#">電子取引・<br/>スキャナ保存</a></li>
                <li class="menu2" :class="{'current':isShowSTFMFM02C03FileList}" @click="clickSonota"><a href="#">その他</a></li>
                <li class="menu3" :class="{'current':isShowSTFMFM02C04FileList}" @click="clickTrashBox"><a href="#">ごみ箱</a></li>
              </ul>
            </nav>
            <STFMFM02C02FileList v-if="isShowSTFMFM02C02FileList" @getErrors="getErrorMessage"></STFMFM02C02FileList>
            <STFMFM02C03FileList v-if="isShowSTFMFM02C03FileList" @getErrors="getErrorMessage"></STFMFM02C03FileList>
            <STFMFM02C04FileList v-if="isShowSTFMFM02C04FileList" @getErrors="getErrorMessage"></STFMFM02C04FileList>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderNav from "@/components/AccountingHeader.vue";
import BusinessHeader from "@/components/BusinessHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import _ from "lodash";
import STFMFM02C02FileList from "./STFMFM02C02FileList.vue";
import STFMFM02C03FileList from "./STFMFM02C03FileList.vue";
import STFMFM02C04FileList from "./STFMFM02C04FileList.vue";
import { API_STFMFM02C29_Initialize, API_STFMFM02C29_SaveInfo} from "@/api/Modules/FM02/STFMFM02C29.js";

export default {
  name: "STFMFM02C29",
  components: {
    HeaderNav,
    BusinessHeader,
    ErrorMessage,
    STFMFM02C02FileList,
    STFMFM02C03FileList,
    STFMFM02C04FileList,
  },
  data() {
    return {
      sessionID: "",
      errors: [],
      isShowSTFMFM02C02FileList : false,
      isShowSTFMFM02C03FileList : false,
      isShowSTFMFM02C04FileList : false,
      showFlag: true,
      isloginHendle: this.$cookies.get("isloginHendle") == "true" ? true : false, 
      businessOperatorCode: "",
      businessOperatorName: "",
    };
  },
  watch: {
  },
  computed: {

  },
  beforeRouteEnter(to, from,next) {
    let fromName = from.name
    if(fromName == "STDSCM01C05"){
      sessionStorage.setItem(
        "isOidc",
        1
      );
    } else {
      sessionStorage.setItem(
        "isOidc",
        0
      );
    }
    next()
  },
  methods: {

    getErrorMessage(value) {
      this.errors = value;
    },

    clickDenshi() {
      this.saveInfo("0");
    },
    clickSonota() {
      this.saveInfo("1");
    },
    clickTrashBox() {
      this.saveInfo("2");
    },

    saveInfo(mode) {
      let params = {
        displayMode : mode
      };

      API_STFMFM02C29_SaveInfo(params).then(
        (response) => {
          if (response.result == "0000") {
            //正常時

            this.isShowSTFMFM02C02FileList = false;
            this.isShowSTFMFM02C03FileList = false;
            this.isShowSTFMFM02C04FileList = false;
            if (mode == "0") {
              this.isShowSTFMFM02C02FileList = true;
            } else if (mode =="1") {
              this.isShowSTFMFM02C03FileList = true;
            } else if (mode == "2") {
              this.isShowSTFMFM02C04FileList = true;
            }

          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }
      );
    },
  },
  created() {
    this.isShowSTFMFM02C02FileList = false;
    this.isShowSTFMFM02C03FileList = false;
    this.isShowSTFMFM02C04FileList = false;

    if (this.$route.query.cp != null) {
      this.showFlag = false;
      this.$cookies.set("encryptFolderKey", this.$route.query.cp);
    }

    let params = {
      encryptFolderKey: this.$cookies.get("encryptFolderKey"),
    }

    API_STFMFM02C29_Initialize(params).then(
      (response) => {
        if (response.result == "0000") {
          //正常時
          this.showFlag = true;
          
          this.isShowSTFMFM02C02FileList = false;
          this.isShowSTFMFM02C03FileList = false;
          this.isShowSTFMFM02C04FileList = false;

          if (response.displayMode == "0") {
            this.isShowSTFMFM02C02FileList = true;
          } else if (response.displayMode == "1") {
            this.isShowSTFMFM02C03FileList = true;
          } else {
            this.isShowSTFMFM02C04FileList = true;
          }
          
          if (response.businessOperatorCode != null) {
            this.businessOperatorCode = response.businessOperatorCode;
          }
          if (response.businessOperatorName != null) {
            this.businessOperatorName = response.businessOperatorName;
          }

          this.$cookies.remove("encryptFolderKey");

        } else if (response.result == "1000") {
          this.$router.push({
            name: "STDSCM01C02",
            params: {}
          });
        } else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      }
    );
  },
};
</script>

<style scoped>
.content-nav2{
  flex:0 0 66px;
}
@media screen and (max-width: 1400px) {
  .body>.inner,.content-body2>.inner{
    max-width: none !important;
    
  }
}

@media (max-width: 768px) {
  .body{
    max-width: 100vw;
  }

  .body>.inner>.content-body2>.inner {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      row-gap: 20px;
    }
}
</style>